import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal, Eyebrow, MaskedLine } from "../components/Reveal";
import { InquiryForm } from "../components/InquiryForm";
import { Marquee } from "../components/Marquee";

export default function Contact() {
  return (
    <>
      <section data-testid="contact-hero" className="relative overflow-hidden bg-[#F5F5F2] pb-16 pt-40 noise-surface">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Eyebrow>Contact</Eyebrow>
          <h1 className="mt-5 font-display text-5xl font-bold uppercase leading-[0.98] text-[#0E1526] sm:text-7xl">
            <MaskedLine delay={0.15}>Talk to the</MaskedLine>
            <MaskedLine delay={0.3} innerClassName="text-amber-500">trading desk.</MaskedLine>
          </h1>
        </div>
      </section>

      <Marquee items={["Reply within one business day", "WhatsApp for urgent quotes", "FOB — CFR — CIF — DAP"]} />

      <section data-testid="contact-main" className="bg-white py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-[1.3fr_1fr] lg:px-8">
          <Reveal>
            <div className="border border-black/10 bg-white p-8 sm:p-10">
              <h2 className="font-display text-3xl font-semibold uppercase text-[#0E1526]">Send an inquiry</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                Include your required grade, monthly volume and destination port for the fastest, most accurate quote.
              </p>
              <div className="mt-8">
                <InquiryForm />
              </div>
            </div>
          </Reveal>

          <div className="space-y-6">
            <Reveal delay={0.1}>
              <div className="border border-black/10 bg-[#F5F5F2] p-8" data-testid="contact-office-card">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500">Head office</p>
                <div className="mt-5 space-y-4 text-sm text-slate-700">
                  <p className="flex gap-3"><MapPin className="h-4 w-4 shrink-0 text-amber-500" />{SITE.address}</p>
                  <a href={SITE.phoneHref} data-testid="contact-phone-link" className="flex gap-3 transition-colors hover:text-[#0E1526]">
                    <Phone className="h-4 w-4 shrink-0 text-amber-500" />{SITE.phone}
                  </a>
                  <a href={`mailto:${SITE.email}`} data-testid="contact-email-link" className="flex gap-3 transition-colors hover:text-[#0E1526]">
                    <Mail className="h-4 w-4 shrink-0 text-amber-500" />{SITE.email}
                  </a>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <a
                href={SITE.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="group flex items-center justify-between border border-emerald-500/40 bg-emerald-500/10 p-8 transition-colors hover:bg-emerald-500/20"
              >
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-emerald-400">Instant chat</p>
                  <p className="mt-2 font-display text-2xl font-semibold uppercase text-[#0E1526]">WhatsApp the desk</p>
                  <p className="mt-1 text-sm text-slate-600">{SITE.whatsapp}</p>
                </div>
                <MessageCircle className="h-8 w-8 text-emerald-400 transition-transform group-hover:scale-110" />
              </a>
            </Reveal>
            <Reveal delay={0.26}>
              <div className="border border-black/10 bg-[#F5F5F2] p-8">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500">Desk hours</p>
                <p className="mt-4 text-sm leading-relaxed text-slate-700">
                  Monday – Saturday, 08:00 – 18:00 Gulf Standard Time<br />
                  WhatsApp monitored around the clock for urgent shipment matters.
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal className="mx-auto mt-16 max-w-7xl px-5 lg:px-8">
          <div className="border border-black/10" data-testid="contact-map">
            <iframe
              title="Terra Bloom DWC LLC office location — Dubai South"
              src={SITE.mapEmbed}
              className="h-[380px] w-full grayscale invert-[0.92] hue-rotate-180"
              loading="lazy"
            />
          </div>
        </Reveal>
      </section>
    </>
  );
}
